import Vue from 'vue'
import Vuex from 'vuex'
import state from './state.js'
import * as actions from './actions.js'
import * as mutations from './mutations.js'
import editor from '@/components/editor/store'
import layout from '@/components/layout/store'
import alignment from "./modules/alignment"
import alignRecords from "./modules/alignRecords"
import ws from './modules/ws'

Vue.use(Vuex);
export default new Vuex.Store({
  state: state,
  mutations: mutations,
  actions: actions,
  modules: {
    ws,
    editor,
    alignment,
    alignRecords,
    layout
  }
})